import { useQuery } from "react-query";
import { AxiosResponse } from "axios";

import { IGetCustomerVehiclesRes } from "types/customer";
import customersService from "api/customersService";

const useGetCustomerVehicles = (customerId: string, enabled: boolean) => {
  return useQuery("customer-vehicles", async () => {
    try {
      const res: AxiosResponse<IGetCustomerVehiclesRes> = await customersService.getCustomerVehicles(customerId)

      return res.data
    } catch (err: any) {
      return err.response
    }
  }, { enabled })
}

export default useGetCustomerVehicles